import { type AnyAction } from 'redux';
import { FETCH_SEARCH_SUCCESS, FETCH_SEARCH_FAILURE } from '../actions/fetch-search-types';
import { SEARCH_CLEAR_RESULTS, SEARCH } from '../actions/search-types';

type SearchState = {
  posts: unknown[];
  query?: unknown;
};

const initialState: SearchState = {
  posts: [],
};

export default (state: SearchState = initialState, action: AnyAction): SearchState => {
  switch (action.type) {
    case SEARCH:
      return { ...state, query: action.payload };
    case FETCH_SEARCH_SUCCESS:
      return { ...state, posts: action.payload.posts };
    case FETCH_SEARCH_FAILURE:
    case SEARCH_CLEAR_RESULTS:
      return { ...state, posts: [] };
    default:
      return state;
  }
};
